module.exports = __webpack_public_path__ + "media/images/pc/top/hairstyle_header_bg-5d2f02ac1855f45930b96b7766baee90.webp";